const CNPJ_LENGTH = 14;
const DV1_WEIGHTS = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const DV2_WEIGHTS = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const ALLOWED_CHAR = /^[0-9A-Z]$/;

export function sanitizeCnpj(value: string | null | undefined): string {
  if (!value) return '';
  return value.toString().toUpperCase().replace(/[^0-9A-Z]/g, '');
}

export function isValidCnpj(value: string | null | undefined): boolean {
  const cnpj = sanitizeCnpj(value);
  if (cnpj.length !== CNPJ_LENGTH) return false;
  if (/^(.)\1{13}$/.test(cnpj)) return false;

  const body = cnpj.substring(0, 12);
  const dv1 = parseInt(cnpj.charAt(12), 10);
  const dv2 = parseInt(cnpj.charAt(13), 10);
  if (Number.isNaN(dv1) || Number.isNaN(dv2)) return false;
  for (const ch of body) if (!ALLOWED_CHAR.test(ch)) return false;

  return calcDv(body, DV1_WEIGHTS) === dv1 && calcDv(body + dv1, DV2_WEIGHTS) === dv2;
}

export function formatCnpj(value: string | null | undefined): string {
  const cnpj = sanitizeCnpj(value);
  if (cnpj.length !== CNPJ_LENGTH) return cnpj;
  return `${cnpj.substring(0, 2)}.${cnpj.substring(2, 5)}.${cnpj.substring(5, 8)}/${cnpj.substring(8, 12)}-${cnpj.substring(12, 14)}`;
}

function calcDv(input: string, weights: number[]): number {
  let sum = 0;
  for (let i = 0; i < input.length; i++) {
    sum += (input.charCodeAt(i) - 48) * weights[i];
  }
  const rest = sum % 11;
  return rest < 2 ? 0 : 11 - rest;
}
